<template>
  <transition name="fade">
    <div class="layer-w" v-show="show">
      <div class="layer" @click="hide" @touchmove.prevent></div>
      <transition name="rise600">
        <div class="c-selectLayer" v-show="show">
          <div class="c-selectLayer__content">
            <div
              class="c-selectLayer__item"
              v-for="(v, index) in list"
              :key="index"
              @click="handlerClick(v, index)"
            >
              {{ v.word }}
            </div>
          </div>
          <div class="fullscreen__padding"></div>
        </div>
      </transition>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean
    },
    list: {
      type: Array
    }
  },
  mounted() {},
  data() {
    return {
      activeIndex: ''
    };
  },
  methods: {
    handlerClick(v, ind) {
      this.$emit('select', v, ind);
    },
    hide() {
      this.$emit('hide');
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/animate.scss';

.c-selectLayer {
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  width: 100%;
  border-radius: 0.12rem 0.12rem 0px 0px;
}
.c-selectLayer__content {
  padding: 0 0.16rem;
}
.c-selectLayer__item {
  font-size: 0.16rem;
  height: 0.56rem;
  line-height: 0.56rem;
  border-bottom: 1px solid rgba(178, 186, 194, 0.15);
  position: relative;
}
.c-selectLayer__bottom {
  overflow: hidden;
  padding: 0.08rem 0 0.08rem;
  font-size: 0.18rem;
  // margin-bottom: constant(safe-area-inset-bottom);
  // margin-bottom: env(safe-area-inset-bottom);
}
.layer-w {
  z-index: 20;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.layer {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
@media (min-width: 768px) {
  .c-selectLayer__item {
    height: 56px;
    line-height: 56px;
    font-size: 16px;
  }
}
</style>
